import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { LayoutLabelType, LayoutType } from "@modules/global-dashboard/models/global-dashboard-interface";

@Component({
	selector: "app-table-top-section",
	templateUrl: "./table-top-section.component.html",
	styleUrls: ["./table-top-section.component.scss"]
})
export class TableTopSectionComponent implements OnInit {
	@Input() set tableTitle(title: string) {
		this.title = title;
	}

	@Input() set firstOptionName(name: string) {
		this.firstOption = name;
	}

	@Input() set secondOptionName(name: string) {
		this.secondOption = name;
	}

	@Input() set showSlideButton(show: boolean) {
		this.showButton = show;
	}

	@Input() set tableIcon(icon: string) {
		this.icon = icon;
	}

	@Input() set selectedKPI(kpi: string) {
		this.kpi = kpi;
	}
	@Input() eventsSelected = 0;

	@Output() switchToCustomerTable: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() hideEvents: EventEmitter<void> = new EventEmitter<void>();

	firstOption!: string;
	secondOption!: string;
	kpi!: string;
	title: string = "";
	showButton: boolean = false;
	icon: string = "";
	titleLabel = "";
	firstLabel = "";
	secondLabel = "";
	readonly LayoutType = LayoutType;
	readonly LayoutLabelType = LayoutLabelType;

	ngOnInit(): void {
		this.setLayoutLabels();
	}

	showCustomerTable(show: number): void {
		this.switchToCustomerTable.emit(Boolean(show));
	}

	hideEventsHandler(): void {
		this.hideEvents.emit();
	}

	setLayoutLabels(): void {
		if (this.title === LayoutType.EVENTS) {
			this.titleLabel = LayoutLabelType.TODOS;
		}
		if (this.title === LayoutType.CUSTOMERS || this.title === LayoutType.PAYGROUPS) {
			this.titleLabel = LayoutLabelType.RUNS;
		}
		this.firstLabel = LayoutLabelType.TODOS;
		this.secondLabel = LayoutLabelType.RUNS;
	}
}
